import React from 'react';
import { Image as ImageIcon } from 'lucide-react';
interface ViewOnLabelLinkProps {
  href: string;
  className?: string;
}
export function ViewOnLabelLink({
  href,
  className = ''
}: ViewOnLabelLinkProps) {
  return <a href={href} target="_blank" rel="noopener noreferrer" title="View this claim on the label artwork" className={`inline-flex shrink-0 items-center gap-1.5 text-sm font-medium text-forest-green transition hover:underline ${className}`} data-id="element-2584" data-mp="1tr5eew03sfb6">
      <ImageIcon className="h-3.5 w-3.5" data-id="element-2585" data-mp="1pr3mhek67093" />
      View on label
    </a>;
}